<section class="py-3 card payment-accounts-section card-div">
  <div class="container-fluid d-flex flex-column h-100">

    <!-- Sticky Top Header Container -->
    <div class="sticky-top-container">
      <div class="row align-items-center mb-4 g-3">
        <div class="col-12 col-md-7 d-flex flex-column align-items-start header-left">
          <div class="sku-badge px-4 py-2 mb-2 d-inline-block">
            <h2 class="sku-name fw-bold m-0 text-break">Payment Accounts</h2>
          </div>
          <span class="footer-text text-muted small">
            {{ headingBottomLabel }}
          </span>
        </div>

        <!-- Right Controls Container -->
        <div class="col-12 col-md-5 d-flex align-items-center gap-2 justify-content-start justify-content-md-end flex-wrap header-right">
          @if(isBranchVisible) {
          <button class="btn add-btn py-2 px-3 d-flex align-items-center gap-2" (click)="addNewAccount()">
            <fa-icon [icon]="faPlus" class="icon-sm"></fa-icon>
            <span class="fw-bold">Add Payment Account</span>
          </button>
          }
        </div>
      </div>
    </div>

    <!-- Responsive Layout Row -->
    <div class="row g-3 flex-grow-1" style="min-height: 0;">
      
      <!-- Left Column: Filters and Table -->
      <div class="col-12 col-md-9 order-md-1 order-2 d-flex flex-column h-100" style="min-height: 0;">
        
        <!-- Filter Card -->
        <div class="filter-card bg-white mb-4">
          <div class="row align-items-center g-2">
            <!-- Search Accounts Input -->
            <div class="col-12 col-md-6 search-input-wrapper position-relative">
              <input type="text" class="form-control filter-search" placeholder="Search by account name..."
                [(ngModel)]="filters.searchTerm"  (input)="onSearchInput()">
              <fa-icon [icon]="faSearch"
                class="position-absolute start-0 top-50 translate-middle-y ms-3 search-icon text-muted"></fa-icon>
            </div>
            
            <!-- Payment Mode Filter -->
            <div class="col-6 col-md-3 dropdown-filter-wrapper">
              <ng-select [items]="paymentModes" bindLabel="label" bindValue="key" [(ngModel)]="filters.mode"
                [clearable]="true" placeholder="All modes" (change)="onFilterChange()" class="custom-ng-select">
              </ng-select>
            </div>
            @if(isBranchVisible) {
            <div class="col-6 col-md-3 dropdown-filter-wrapper">
              <ng-select [items]="branches" bindLabel="name" bindValue="_id" [(ngModel)]="filters.branch"
                [clearable]="true" placeholder="All branches" (change)="onFilterChange()" class="custom-ng-select">
              </ng-select>
            </div>
            }
          </div>
        </div>

        <div class="flex-grow-1 table-box-wrapper" style="min-height: 0;">
          <div class="card rounded-4 thick-border-gray shadow-none h-100">
            <div class="table-responsive h-100" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="500" (scrolled)="onscrollTable()">
              <table class="table custom-table align-middle m-0">
                <thead>
                  <tr>
                    <th class="fw-semibold text-nowrap">Account</th>
                    <th class="fw-semibold text-nowrap">Payment mode</th>
                    <th  class="fw-semibold text-nowrap">Branch</th>
                    <th class="fw-semibold text-nowrap">Balance account</th>
                    <th class="fw-semibold text-nowrap">Settlement</th>
                    <th class="fw-semibold text-nowrap">Status</th>
                    <th class="fw-semibold text-center text-nowrap">Action</th>
                  </tr>
                </thead>
                <tbody>
                  @for (acc of accountList; track acc._id; let i = $index) {
                  <tr class="normal-row cursor-pointer" (click)="openAccountDetail(acc)">
                    <td class="account-name fw-sm-bold text-uppercase">
                      {{ acc.accountName }}
                    </td>

                    <td class="payment-mode fw-sm-bold">
                      @if (acc.paymentType === 'UPI') {
                        {{ acc.paymentType }}
                      } @else {
                        {{ (acc.paymentType | capitalSpace) || '-' }}
                      }
                    </td>

                    <td class="branch-name">
                      {{ acc.company?.name || '-' }}
                    </td>

                    <td class="balance-account">
                      @if (acc.settlementType === 'Manual') {
                        <span class="manual-at-settlement-badge">At settlement</span>
                      } @else {
                        <span class="balance-account-name fw-sm-bold">
                          {{ acc.balanceAccountId?.accountName || '-' }}
                        </span>
                      }
                    </td>

                    <td class="settlement-timing">
                      @if (acc.settlementType === 'Manual') {
                        <span class="timing-label-gray">Manual</span>
                      } @else if (acc.settlementType === 'Immediate') {
                        <div class="d-flex flex-column gap-0">
                          <span class="timing-label-gray">Immediate</span>
                        </div>
                      } @else if(acc.settlementType === 'Auto'){
                        <div class="d-flex flex-column gap-0">
                          <span class="timing-label-orange">Delay {{ acc.settlementPeriod || 0 }} days</span>
                        </div>
                      } @else {
                        <span class="timing-label-gray">-</span>
                      }
                    </td>

                    <td class="status-cell">
                      <span class="status-label fw-sm-bold" [ngClass]="acc.status ? 'text-green' : 'text-red'">
                        {{ acc.status ? 'Active' : 'Inactive' }}
                      </span>
                    </td>

                    <td class="text-center action-cell">
                      <a class="btn app-btn-primary btn-sm" (click)="openAccountDetail(acc); $event.stopPropagation()">
                        <fa-icon [icon]="faEye" data-bs-toggle="tooltip" ngbTooltip="View details" [placement]="'top'"></fa-icon>
                      </a>
                    </td>
                  </tr>
                  }

                  <!-- Loader Row -->
                  @if (loader) {
                  <tr>
                    <td colspan="8" class="text-center py-4">
                      <app-loader></app-loader>
                    </td>
                  </tr>
                  }

                  <!-- Error Message Row inside Table -->
                  @if (!loader && errorMessage) {
                  <tr>
                    <td colspan="8" class="text-center py-5 text-danger small fw-semibold">
                      Failed to load payment accounts: {{ errorMessage }}
                    </td>
                  </tr>
                  }

                  <!-- Empty State Row -->
                  @if (!loader && !errorMessage && accountList.length === 0) {
                  <tr>
                    <td colspan="8" class="text-center py-5 text-muted small">
                      No payment accounts found.
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>

      <!-- Right Column: Highlight Cards -->
      <div class="col-12 col-md-3 order-md-2 order-1">
        <div class="row g-3">
          
          <!-- Card 1: Total accounts -->
          <div class="col-12 col-sm-6 col-md-12">
            <div class="balance-highlight-card h-100 bg-white">
              <div class="card-top-label">Total accounts</div>
              <div class="card-value py-1 text-truncate">{{ cardTotalAccountsValue }}</div>
              <div class="card-footer-label">Active</div>
            </div>
          </div>
          @if(isBranchVisible) {
          <div class="col-12 col-sm-6 col-md-12">
            <div class="balance-highlight-card h-100 bg-white">
              <div class="card-top-label">Branches</div>
              <div class="card-value py-1 text-truncate">{{ cardBranchesValue }}</div>
              <div class="card-footer-label">With balance accounts</div>
            </div>
          </div>
          }

          <!-- Card 3: Unlinked accounts -->
          <div class="col-12 col-sm-6 col-md-12">
            <div class="balance-highlight-card h-100 bg-white">
              <div class="card-top-label">Unlinked accounts</div>
              <div class="card-value py-1 text-truncate">{{ cardUnlinkedAccountsValue }}</div>
              <div class="card-footer-label">No settlement target</div>
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>
</section>

<ng-template #accountFormModal let-offcanvas>
  <app-new-payment-account
    [mode]="mode"
    [branches]="branches"
    [editAccountData]="editAccountData"
    (accountSave)="onAccountSave($event)"
    (accountCancel)="onFormCancel()">
  </app-new-payment-account>
</ng-template>

@if (toasterMsg) {
  <app-toaster [title]="toasterMsg" (closeToaster)="toasterMsg = ''"></app-toaster>
}